var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-linker"},[_c('TheHeader',_vm._b({},'TheHeader',{
      currentUser: _vm.currentUser,
      spaces: _vm.spaces,
      currentSpace: _vm.currentSpace,
      createSpace: _vm.createSpace,
      logout: _vm.logout,
      selectSpace: _vm.selectSpace,
      isAdmin: _vm.isAdmin,
      isSpaceRoute: _vm.isSpaceRoute,
      isSuperAdminRoute: _vm.isSuperAdminRoute,
      isSuperAdmin: _vm.isSuperAdmin,
    },false)),_c('v-content',[_c('transition',{attrs:{"name":"top-level","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }